import type { AxiosInstance, AxiosRequestConfig } from 'axios'
import type { IInvitationDetails, IPeselDetails } from '@/typings/invitation'
import { CREATED_CODE } from '@/config/httpCodes.ts'

export default (axios: AxiosInstance) => ({
    getInvitationDetails: async (token: string): Promise<IInvitationDetails> => {
        const { data } = await axios.get<IInvitationDetails>(
            `/guardian/invitation/${token}/check`,
            {
                omitAuthorization: true,
            },
        )

        return data
    },

    sendQuestionnaire: async (
        token: string,
        formData: FormData,
        config: AxiosRequestConfig = {},
    ): Promise<boolean> => {
        const { status } = await axios.post(
            `/guardian/invitation/${token}/questionnaire/create`,
            formData,
            {
                ...config,
                omitAuthorization: true,
            },
        )

        return status === CREATED_CODE
    },

    checkPesel: async (token: string, pesel: string): Promise<IPeselDetails> => {
        const { data } = await axios.post<IPeselDetails>(
            `/guardian/invitation/${token}/pesel/details`,
            {
                pesel,
            },
            {
                omitAuthorization: true,
            },
        )

        return data
    },
})
